import React from "react";
import { Link } from "react-router-dom";
import { MEDIA } from "../lib/media";

export default function NotFound() {
  return (
    <div className="relative min-h-[70vh] flex items-center justify-center text-center overflow-hidden">
      <img src={MEDIA.mist} alt="" className="absolute inset-0 h-full w-full object-cover" />
      <div className="absolute inset-0 bg-forest/50" />
      <div className="relative text-ivory px-6">
        <span className="eyebrow text-ivory/70">404</span>
        <h1 className="serif text-5xl lg:text-7xl mt-3 mb-4">Lost in the mist?</h1>
        <p className="text-ivory/80 mb-8">Let's take you back.</p>
        <Link to="/" className="bg-ivory text-forest px-8 py-4 rounded-[9px] uppercase text-xs tracking-[0.18em] font-medium hover:bg-sage transition-colors" data-testid="notfound-home">Back to Home</Link>
      </div>
    </div>
  );
}
